import { Icon, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, cn } from "@nexus/ui";
import { useTranslation } from "react-i18next";

import type { OpportunityHubViewMode } from "./hub-chrome.types.js";

const VIEWS: { value: OpportunityHubViewMode; icon: "rows-3" | "layout-grid" }[] = [
  { value: "table", icon: "rows-3" },
  { value: "cards", icon: "layout-grid" },
];

export interface OpportunityHubViewToggleProps {
  view: OpportunityHubViewMode;
  onViewChange: (view: OpportunityHubViewMode) => void;
}

export function OpportunityHubViewToggle({ view, onViewChange }: OpportunityHubViewToggleProps) {
  const { t } = useTranslation();

  return (
    <TooltipProvider delayDuration={400}>
      <div
        className="inline-flex items-center rounded-md border border-primary/30 shadow-xs dark:border-primary/40"
        role="group"
        aria-label={t("personaOpportunities.active.viewToggleAria", "Switch view")}
      >
        {VIEWS.map((entry) => (
          <Tooltip key={entry.value}>
            <TooltipTrigger asChild>
              <button
                type="button"
                onClick={() => onViewChange(entry.value)}
                aria-pressed={view === entry.value}
                aria-label={t(`personaOpportunities.active.view.${entry.value}`)}
                className={cn(
                  "inline-flex min-h-11 min-w-11 items-center justify-center text-sm transition-colors first:rounded-l-md last:rounded-r-md [@media(hover:hover)_and_(pointer:fine)]:min-h-8 [@media(hover:hover)_and_(pointer:fine)]:min-w-8",
                  view === entry.value
                    ? "bg-primary/10 text-primary dark:bg-primary/20"
                    : "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
                )}
              >
                <Icon name={entry.icon} size="xs" color="inherit" />
              </button>
            </TooltipTrigger>
            <TooltipContent>{t(`personaOpportunities.active.view.${entry.value}`)}</TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
}
